import { Button } from 'antd';
import styled from 'styled-components';

const StepActionsWrapper = styled.div`
  text-align: right;

  .step-action-button-margin {
    margin-left: 8px;
  }
`;

interface HSMSStepActionsProps {
  currentStep: number;
  setCurrentStep: (step: number) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  nextAction: (...args: any) => any; // Can pass any function
  finalButtonText?: string;
  isLoading?: boolean;
}

export const HSMSStepActions = ({
  currentStep,
  setCurrentStep,
  nextAction,
  finalButtonText,
  isLoading,
}: HSMSStepActionsProps) => (
  <StepActionsWrapper className="step-actions">
    {currentStep > 0 && (
      <Button
        size="large"
        onClick={() => {
          setCurrentStep(currentStep - 1);
          window.scrollTo(0, 0);
        }}
        disabled={isLoading}
      >
        Previous
      </Button>
    )}
    {currentStep < 2 && (
      <Button
        className="step-action-button-margin"
        size="large"
        type="primary"
        onClick={async () => {
          await nextAction();
          window.scrollTo(0, 0);
        }}
        disabled={isLoading}
      >
        Next
      </Button>
    )}
    {currentStep === 2 && (
      <Button
        className="step-action-button-margin"
        size="large"
        type="primary"
        onClick={nextAction}
        loading={isLoading}
        disabled={isLoading}
      >
        {finalButtonText || 'Done'}
      </Button>
    )}
  </StepActionsWrapper>
);
